import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: "24px",
    margin: "0 auto",
    backgroundColor: "#fff",
    minHeight: "100vh",
    "@media (max-width: 768px)": {
      padding: "16px"
    }
  },
  header: {
    marginBottom: "32px",
    "& h1": {
      fontSize: "24px"
    }
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: "700",
    color: "#1a202c",
    margin: "0 0 16px 0",
    lineHeight: "1.2",
    "@media (max-width: 768px)": {
      fontSize: "2rem"
    }
  },
  progressSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    gap: "8px"
  },
  progressText: {
    fontSize: "1rem",
    fontWeight: "400",
    color: "#4a5568"
  },
  progressBar: {
    width: "100%",
    height: "8px",
    backgroundColor: "#e2e8f0",
    borderRadius: "4px",
    overflow: "hidden"
  },
  progressFill: {
    height: "100%",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "4px",
    transition: "width 0.3s ease"
  },
  contentGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 350px",
    gap: "32px",
    alignItems: "start",
    "@media (max-width: 1000px)": {
      gridTemplateColumns: "1fr",
      gap: "24px"
    }
  },
  leftContent: {
    background: "white",
    borderRadius: "12px",
    textAlign: "left"
    // boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)"
    // "@media (max-width: 768px)": {
    //   padding: "24px 16px"
    // }
  },
  stepsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px"
  },
  stepCard: {
    display: "flex",
    gap: "16px",
    padding: "20px",
    alignItems: "center",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#3182ce",
      boxShadow: "0 2px 8px rgba(49, 130, 206, 0.1)"
    },
    "@media (max-width: 480px)": {
      flexDirection: "column",
      alignItems: "flex-end"
    }
  },
  stepNumber: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#3182ce",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "600",
    fontSize: "1rem",
    flexShrink: 0
  },
  stepContent: {
    flex: 1
  },
  stepTitle: {
    fontSize: "1.125rem",
    fontWeight: "400",
    color: "#2d3748",
    margin: "0 0 8px 0",
    lineHeight: "1.4"
  },
  stepDescription: {
    fontSize: "0.875rem",
    color: "#718096",
    margin: 0,
    lineHeight: "1.5"
  },
  rightContent: {
    "@media (max-width: 1000px)": {
      order: -1
    }
  },
  sidebarCard: {
    background: "white",
    borderRadius: "12px",
    // padding: "24px",
    // boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    textAlign: "left"
    // border: "1px solid #e2e8f0"
  },
  sidebarTitle: {
    fontSize: "1.25rem",
    fontWeight: "600",
    color: "#2d3748",
    margin: "0 0 8px 0"
  },
  sidebarDescription: {
    fontSize: "0.875rem",
    color: "#718096",
    margin: "0 0 20px 0",
    lineHeight: "1.5"
  },
  completedIcon: {
    fontSize: "32px",
    color: "#38a169"
  },
  buttonGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "12px"
  },
  startButton: {
    width: "100%",
    marginBottom: "8px"
  },
  startHereButton: {
    width: "100%"
  },
  mobileVideoHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    cursor: "pointer",

    [theme.breakpoints.up("md")]: {
      display: "block",
      cursor: "auto"
    }
  },
  headerText: {
    flex: 1,

    [theme.breakpoints.up("md")]: {
      marginBottom: theme.spacing(2)
    }
  },
  playIcon: {
    color: theme.palette.primary.main,
    marginLeft: 2
  },
  playIconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 48,
    height: 48,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: "4px",
    marginLeft: 6,
    transition: "all 0.3s ease",
    cursor: "pointer",
    flexShrink: 0,

    "&:hover": {
      transform: "scale(1.05)"
    },

    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },

  playing: {
    backgroundColor: theme.palette.secondary.main,

    "&:hover": {
      backgroundColor: theme.palette.secondary.dark
    }
  },
  videoWrapper: {
    borderRadius: 8,
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    marginBottom: theme.spacing(3),
    "& .react-player__preview": {
      borderRadius: 8
    },
    "& .react-player__play-icon": {
      border: 0
    }
  },
  videoVisible: {
    display: "block",
    opacity: 1,
    transform: "translateY(0)"
  },

  videoHidden: {
    display: "none",
    opacity: 0,
    transform: "translateY(-10px)",

    [theme.breakpoints.up("md")]: {
      display: "block !important",
      opacity: 1,
      transform: "translateY(0)"
    }
  },

  customPlayButton: {
    background: "rgba(255, 255, 255, 0.9)",
    borderRadius: "50%",
    width: 80,
    height: 80,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#ff0000",
    border: "none",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "white",
      transform: "scale(1.1)"
    }
  },

  disabledText: {
    color: "#ff0000",
    fontSize: "14px",
    marginBlock: "25px 2px"
  },

  playButton: {
    background: "#ff0000",
    color: "white",
    border: "none",
    padding: "12px 24px",
    borderRadius: 25,
    display: "flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 16,
    transition: "background 0.3s ease",
    "&:hover": {
      background: "#cc0000"
    }
  },

  playIconWrapper: {
    background: "rgba(255, 255, 255, 0.95)",
    borderRadius: "50%",
    width: 80,
    height: 80,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#ff0000",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.1)",
      background: "white"
    }
  }
}));
